import { styled } from "styled-components";

export const TableContainer = styled.div`
  height: 70%;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 8px;
    border-radius: 8px;
    background-color: var(--base01);
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--principal);
    border-radius: 5px;
  }

  > table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    text-align: center;
    padding: 10px;

    > thead > tr > th {
      font-weight: 600;
      padding: 20px;
      padding: 10px;
      font-size: 0.8rem;
    }
    > tbody > tr > td {
      border-bottom: 1px solid var(--grayDA);
      border-top: 1px solid var(--grayA5);
      padding: 15px;
      font-size: 0.8rem;
    }
  }

  .text-start{
    text-align: left;
  }

  .ativo {
    display: flex;
    align-items: center;
    justify-content: center;

    > p {
      font-size: 0.8rem;
      width: 60px;
    }
  }

  a {
    color: var(--principal);
    font-size: 0.8rem;
  }

  .loading{
    height: 300px;

    div{
      margin-top: 20px;
      height: 100%;
    }
  }

  .status{
    font-size: 12px;
    color: white;
    border-radius: 100px;
    padding: 6px 20px;
  }

  .andamento{
    background-color: #FFBE00;
  }

  .images{
    width: 90px;
    height: 90px;
    padding: 2px;
    border-radius: 6px;
    border: solid 2px #7D0000;
  }

  .arquivos{
    gap: 30px;
    display: flex;
    margin-top: 10px;
    align-items: center;

    a{
      color: #0000EE;
    }

    width: 100%;
    flex-wrap: wrap;
  }

  .minWidth150{
    width: 150px;
    text-align: left;
  }

  .excluir{
    svg {
      cursor: pointer;
      width: 22px;
      height: 22px;

      path,
      polygon,
      rect,
      circle,
      ellipse {
        fill: red;
      }
    }
    
    .verde{
    path,
      polygon,
      rect,
      circle,
      ellipse {
        fill: green;
      }
    }
  }


`;
